import { queryOptions } from '@tanstack/react-query';
import api from '@/api/api';
import { CueingBlockListResponseSchema, CueingStepListResponseSchema } from '@/api/schema/cueing';

export const fetchProcedureCueingBlocks = async (procedureId: string) => {
  const response = await api.get(`procedures/${procedureId}/cueing-blocks`);
  const json = await response.json();
  return CueingBlockListResponseSchema.parse(json);
};

export const getProcedureQueingBlocksQueryOptions = (procedureId: string) => queryOptions({
  queryKey: [ 'procedures', procedureId, 'cueingBlocks' ],
  queryFn: () => fetchProcedureCueingBlocks(procedureId),
});

export const getProcedureQueingStepsQueryOptions = (procedureId: string) => queryOptions({
  queryKey: [ 'procedures', procedureId, 'cueingSteps' ],
  queryFn: async () => {
    const response = await api.get(`procedures/${procedureId}/cueing-steps`);
    const json = await response.json();
    return CueingStepListResponseSchema.parse(json);
  },
});
